'use client';

import React from 'react';
import Link from 'next/link';

export default function NotFound() {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: '#F2F3F3' }}
    >
      <div className="text-center px-4">
        <div
          className="inline-flex items-center justify-center w-24 h-24 rounded-full mb-8"
          style={{ backgroundColor: '#122658' }}
        >
          <span
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 700,
              fontSize: '32px',
              color: '#ffffff',
            }}
          >
            404
          </span>
        </div>
        <h1
          className="mb-4"
          style={{
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 700,
            fontSize: '36px',
            color: '#122658',
          }}
        >
          Page Not Found
        </h1>
        <p
          className="mb-8 max-w-md mx-auto"
          style={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: '15px',
            color: '#7F7F90',
            lineHeight: 1.7,
          }}
        >
          The page you are looking for does not exist or has been moved. Please return to the homepage.
        </p>
        <Link
          href="/"
          className="inline-flex items-center justify-center px-8 py-3 text-white font-medium uppercase tracking-widest transition-all duration-200 hover:opacity-90"
          style={{
            backgroundColor: '#0066CC',
            borderRadius: '7px',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
            letterSpacing: '2px',
            textDecoration: 'none',
          }}
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}